import SearchIcon from '@mui/icons-material/Search'
import InputAdornment from '@mui/material/InputAdornment'
import { styled, alpha } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import type { TextFieldProps } from '@mui/material/TextField'

import React from 'react'

interface SidebarSearchFieldProps extends Omit<TextFieldProps, 'variant'> {
  startIcon?: React.ReactNode
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius * 4,
    backgroundColor: theme.palette.background.paper,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.borderColors?.light ?? alpha(theme.palette.divider, 0.4),
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
}))

export function SidebarSearchField({
  startIcon = <SearchIcon />,
  InputProps,
  slotProps,
  ...props
}: SidebarSearchFieldProps) {
  const inputStartAdornment = (InputProps as any)?.startAdornment ??
    (slotProps?.input as any)?.startAdornment ?? (
      <InputAdornment position="start">{startIcon}</InputAdornment>
    )

  const mergedInputSlotProps = {
    ...(slotProps?.input as Record<string, unknown> | undefined),
    ...(InputProps as Record<string, unknown> | undefined),
    startAdornment: inputStartAdornment,
  }

  const mergedSlotProps = {
    ...slotProps,
    input: mergedInputSlotProps,
  }

  return (
    <StyledTextField
      variant="outlined"
      size="small"
      autoComplete="off"
      type="search"
      slotProps={mergedSlotProps}
      {...props}
    />
  )
}
